import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Select } from '@ratehub/base-ui';

import { AMORTIZATION_OPTIONS_EXTENDED } from '../definitions/AmortizationTermOptions';
import AMORTIZATION_MESSAGES from '../definitions/AmortizationTermMessages';


// Other uses of this shared definition require strings, we want numbers.
const AMORITZATION_OPTIONS_NUMBER = AMORTIZATION_OPTIONS_EXTENDED.map(item => Number(item));

function QuestionAmortization({ name = 'amortization', value, ...otherProps }) {
    return (
        <Select
            name={name}
            value={value}
            options={AMORITZATION_OPTIONS_NUMBER}
            // Used to format the message into "{term}-year"
            renderOptionLabel={term => (
                <FormattedMessage
                    {...AMORTIZATION_MESSAGES.TERM_MESSAGE}
                    values={{ term }}
                />
            )}
            label={(
                <FormattedMessage
                    id="web-components.mortgageRateTableV2+Filter.purchaseAmortizationLabel"
                    defaultMessage="Amortization"
                />
            )}
            {...otherProps}
        />
    );
}

QuestionAmortization.propTypes = {
    name: PropTypes.string,
    value: PropTypes.oneOf(AMORITZATION_OPTIONS_NUMBER),
};

export default QuestionAmortization;
